import { render } from "./ModalPaymentEfectivo.vue?vue&type=template&id=71b92ef2&scoped=true"
import script from "./ModalPaymentEfectivo.vue?vue&type=script&lang=js"
export * from "./ModalPaymentEfectivo.vue?vue&type=script&lang=js"

import "./ModalPaymentEfectivo.vue?vue&type=style&index=0&id=71b92ef2&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\montalvo.ti\\front-on\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71b92ef2"]])

export default __exports__